<div class="weekly-report">
    <div class="weekly-report__header">
        <div class="weekly-report__controls">
            <app-custom-date-filter [options]="dateFilterOptions"
                (dateSeletected)="setDateFilterPeriods($event)"></app-custom-date-filter>

            <form [formGroup]="viewForm" class="weekly-report__form">
                <mat-form-field class="weekly-report__select">
                    <mat-label>View Type</mat-label>
                    <mat-select formControlName="viewType">
                        <mat-option [value]="viewTypes.Projects">By Projects</mat-option>
                        <mat-option [value]="viewTypes.Users">By Users</mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
    </div>

    <div class="weekly-report__content">
        <div class="weekly-report__table mat-elevation-z8 mat-table-responsive">
            <table mat-table [dataSource]="weeklyData" class="weekly-report__mat-table">
                <!-- Name Column -->
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ viewForm.get('viewType')?.value === viewTypes.Projects ? 'Project' : 'User' }}
                    </th>
                    <td mat-cell *matCellDef="let item">
                        <div class="weekly-report__task">
                            <span class="weekly-report__color-dot" [style.background-color]="item.color"></span>
                            <div class="weekly-report__task-details">
                                <div class="weekly-report__name">{{ item.name }}</div>
                            </div>
                        </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>Total</td>
                </ng-container>

                <!-- Monday Column -->
                <ng-container matColumnDef="monday">
                    <th mat-header-cell *matHeaderCellDef>Mon</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.monday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('monday')) }}
                    </td>
                </ng-container>

                <!-- Tuesday Column -->
                <ng-container matColumnDef="tuesday">
                    <th mat-header-cell *matHeaderCellDef>Tue</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.tuesday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('tuesday')) }}
                    </td>
                </ng-container>

                <!-- Wednesday Column -->
                <ng-container matColumnDef="wednesday">
                    <th mat-header-cell *matHeaderCellDef>Wed</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.wednesday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('wednesday')) }}
                    </td>
                </ng-container>

                <!-- Thursday Column -->
                <ng-container matColumnDef="thursday">
                    <th mat-header-cell *matHeaderCellDef>Thu</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.thursday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('thursday')) }}
                    </td>
                </ng-container>

                <!-- Friday Column -->
                <ng-container matColumnDef="friday">
                    <th mat-header-cell *matHeaderCellDef>Fri</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.friday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('friday')) }}
                    </td>
                </ng-container>

                <!-- Saturday Column -->
                <ng-container matColumnDef="saturday">
                    <th mat-header-cell *matHeaderCellDef>Sat</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.saturday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('saturday')) }}
                    </td>
                </ng-container>

                <!-- Sunday Column -->
                <ng-container matColumnDef="sunday">
                    <th mat-header-cell *matHeaderCellDef>Sun</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.sunday) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(getDayTotal('sunday')) }}
                    </td>
                </ng-container>

                <!-- Total Column -->
                <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef>Total</th>
                    <td mat-cell *matCellDef="let track">{{ formatHours(track.total) }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ formatHours(totalHours) }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>

            <div *ngIf="weeklyData.length === 0" class="weekly-report__no-data">
                No time tracks found for this week.
            </div>
        </div>
    </div>
</div>
